import * as Sentry from "@sentry/react";
import { UIView } from "@uirouter/react";
import React from "react";
import { QueryClientProvider } from "react-query";

import { GlobalBanner } from "./components/banner";
import { CookiePolicy } from "./components/cookie-policy";
import { AllImagesProvider } from "./components/image/all-images-context";
import { GlobalLoader, ProgressContainer } from "./components/loader";
import { Spinner } from "./components/loader/icon";
import { GlobalOverlayProvider } from "./components/overlay/context";
import "./i18n/index.tsx";
import { SystemErrorPage } from "./pages/error/general";
import { SingleKycProvider } from "./pages/kyc-kyb-aml/individual-kyc/single/context";
import { StakeContextProvider } from "./pages/staking/single/context";
import { useAuthEffects } from "./store/auth/effects";
import { useBannerEffects } from "./store/banner/effects";
import { queryClient } from "./store/client-query";
import { runAllSubscriptions } from "./store/eventstore/all-effects";
import { useSocket } from "./store/socket";

// Load all effects
runAllSubscriptions();

export default function () {
  // Add effects
  useAuthEffects();
  useBannerEffects();
  useSocket();

  return (
    <React.Suspense
      fallback={
        <ProgressContainer>
          <Spinner />
        </ProgressContainer>
      }
    >
      <Sentry.ErrorBoundary fallback={<SystemErrorPage />}>
        <QueryClientProvider client={queryClient}>
          <StakeContextProvider>
            <SingleKycProvider>
              <AllImagesProvider>
                <GlobalOverlayProvider>
                  <GlobalBanner />
                  <UIView />
                  <UIView name="overlay" />
                  <CookiePolicy />
                </GlobalOverlayProvider>
                <GlobalLoader />
              </AllImagesProvider>
            </SingleKycProvider>
          </StakeContextProvider>
        </QueryClientProvider>
      </Sentry.ErrorBoundary>
    </React.Suspense>
  );
}
